import getConfig from "next/config";
import { connect } from "react-redux";

import CredexUserPromoBannerDefaultLabel from "@components/CredexUserPromoBanner/CredexUserPromoBannerDefaultLabel";
import CredexUserPromoBannerExtraInfoLabel from "@components/CredexUserPromoBanner/CredexUserPromoBannerExtraInfoLabel";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const layoutLabel = {
  default: CredexUserPromoBannerDefaultLabel,
  extraInfo: CredexUserPromoBannerExtraInfoLabel,
};

// Bussiness has revoked credex modal. Development code is not finished but kept for future reference.

const CredexUserPromoBanner = ({
  layout = "default",
  customer,
  installmentValue,
  credexConfig,
}) => {
  const LabelComponent = layoutLabel[layout];

  if (!credexConfig || !customer) {
    return null;
  }

  return (
    <div
      className="relative flex items-center justify-between gap-[8px] overflow-hidden rounded-[4px] text-white bg-cover bg-top bg-no-repeat px-[16px] py-[12px]"
      role="region"
      aria-label="informational-banner"
      style={{
        backgroundImage: `url(${settings.websiteStatics}/images/credex/credex-customer-promo.png)`,
      }}
    >
      <div className="z-[2]">
        <LabelComponent
          firstName={customer?.first_name}
          credexConfig={credexConfig}
          installmentValue={installmentValue}
        />
      </div>
    </div>
  );
};

export default connect((state) => ({
  customer: state.user.customer,
  credexConfig: state.credex.data,
}))(CredexUserPromoBanner);
